import { SectionHeading } from '@ets/design-system';
import { useIntl } from 'react-intl';

const SessionHeading = () => {
  const intl = useIntl();

  return (
    <SectionHeading
      size="l"
      sticky
      style={{ margin: '4rem 0 0 0' }}
      title={intl.formatMessage({ id: 'settings.security.session' })}
      testId="session"
    />
  );
};

export default SessionHeading;
